module.exports = __webpack_public_path__ + "static/media/rawpixel-coms.539d3962.jpg";